import { fetch } from '../../utils/dataAccess';

export function error(error) {
  return { type: 'PAYMENT_METHOD_DELETE_ERROR', error };
}

export function loading(loading) {
  return { type: 'PAYMENT_METHOD_DELETE_LOADING', loading };
}

export function success(deleted) {
  return { type: 'PAYMENT_METHOD_DELETE_SUCCESS', deleted };
}

export function del(item, callback) {
  return dispatch => {
    dispatch(loading(true));

    return fetch(item['@id'], { method: 'DELETE' })
      .then(() => {
        dispatch(loading(false));
        dispatch(success(item));
        if (typeof callback === 'function') {
          callback();
        }
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}
